/**
 * 9 宫格 anchor 翻译成 px 坐标。跟 ai-service compositor._resolve_position 算法对齐。
 *
 * canvasW/canvasH = 渲染容器尺寸(等比方形或长方形都支持)。
 * elementW/elementH = 元素自身尺寸。
 * 返回相对容器左上角的 (x, y) px。
 */
import type { AnchorPosition } from "../../../api/posterService";

export function resolveAnchorXY(
  canvasW: number,
  canvasH: number,
  elementW: number,
  elementH: number,
  position: AnchorPosition,
  padding: number,
  offsetY = 0
): { x: number; y: number } {
  const cx = (canvasW - elementW) / 2;
  const cy = (canvasH - elementH) / 2;
  const topY = padding;
  const botY = canvasH - elementH - padding + offsetY;
  const leftX = padding;
  const rightX = canvasW - elementW - padding;
  switch (position) {
    case "top-left":
      return { x: leftX, y: topY };
    case "top-center":
      return { x: cx, y: topY };
    case "top-right":
      return { x: rightX, y: topY };
    case "center-left":
      return { x: leftX, y: cy };
    case "center":
      return { x: cx, y: cy };
    case "center-right":
      return { x: rightX, y: cy };
    case "bottom-left":
      return { x: leftX, y: botY };
    case "bottom-center":
      return { x: cx, y: botY };
    case "bottom-right":
      return { x: rightX, y: botY };
  }
}
